export default function SkillsDeveloped() {
  const skills = [
    { icon: 'ri-user-search-line', title: 'Работа с потребностями', desc: 'Техники выявления истинных потребностей клиента, вопросы SPIN, глубинное интервью' },
    { icon: 'ri-shield-flash-line', title: 'Работа с возражениями', desc: 'Алгоритмы обработки ценовых, продуктовых и психологических возражений' },
    { icon: 'ri-chat-1-line', title: 'Переговоры', desc: 'Тактика win-win, работа с первыми лицами и закупщиками, закрытие сложных сделок' },
    { icon: 'ri-mail-send-line', title: 'Продажи через переписку', desc: 'Email, мессенджеры, соцсети — текстовые техники для вовлечения и продаж' },
    { icon: 'ri-scales-3-line', title: 'Аргументация', desc: 'Выстраивание системы аргументов под тип клиента, техника «характеристика-выгода»' },
    { icon: 'ri-briefcase-5-line', title: 'Закрытие сделки', desc: 'Техники мягкого закрытия, работа с отсрочками, доведение до подписания' },
    { icon: 'ri-money-dollar-circle-line', title: 'Работа с ценой', desc: 'Подача цены, обоснование стоимости, допродажи и увеличение среднего чека' },
    { icon: 'ri-loop-left-line', title: 'Повторные продажи', desc: 'Выстраивание долгосрочных отношений, кросс-продажи, лояльность клиентов' },
    { icon: 'ri-computer-line', title: 'CRM и воронка продаж', desc: 'Эффективное использование CRM, управление воронкой, прогнозирование' },
    { icon: 'ri-team-line', title: 'Командная работа', desc: 'Обмен лучшими практиками, коллегиальная поддержка, единые стандарты' },
  ];

  return (
    <section id="skills" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие навыки развиваются
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Обучение охватывает весь цикл продаж — от первого контакта до повторных сделок и работы с базой клиентов
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {skills.map((skill, i) => (
            <div key={i} className="bg-white p-6 rounded-xl hover:ring-2 hover:ring-teal-200 transition-all group text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${skill.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{skill.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{skill.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}